<template>
  <div class="usuarios-container">
    <!-- Unified Container -->
    <div class="unified-container">
      <!-- Header Section -->
      <div class="header-section">
        <div class="title-section">
          <v-icon class="title-icon" color="white">mdi-account</v-icon>
          <div class="title-text">
            <h1 class="main-title">USUARIOS</h1>
            <p class="subtitle">Gestión de Usuarios del Sistema</p>
          </div>
        </div>
        <div class="action-section">
          <v-dialog
            v-model="dialog"
            max-width="700px"
            persistent
            overlay-color="black"
            overlay-opacity="0.8"
          >
            <template v-slot:activator="{ on }">
              <v-btn color="primary" class="create-btn" v-on="on" elevation="2">
                <v-icon left>mdi-plus-thick</v-icon>
                NUEVO USUARIO
              </v-btn>
            </template>
            <v-card class="modern-dialog">
              <v-card-title class="dialog-header">
                <v-icon color="white" class="mr-2">mdi-account</v-icon>
                <span class="dialog-title">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text class="dialog-content">
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        v-model="editedItem.cedula"
                        label="Cédula"
                        variant="outlined"
                        hide-details
                        class="modern-field"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        v-model="editedItem.nombre"
                        label="Nombre Completo"
                        variant="outlined"
                        hide-details
                        class="modern-field"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        v-model="editedItem.correo"
                        :rules="[rules.required, rules.email]"
                        label="Correo Corporativo"
                        variant="outlined"
                        hide-details
                        class="modern-field"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        v-model="editedItem.contrasena"
                        label="Contraseña"
                        :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="show ? 'text' : 'password'"
                        @click:append="show = !show"
                        variant="outlined"
                        hide-details
                        class="modern-field"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-select
                        item-value="idRol"
                        item-text="nombreRol"
                        :items="roles"
                        label="Rol"
                        v-model="editedItem.idRol"
                        variant="outlined"
                        hide-details
                        class="modern-field"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-select
                        item-value="idArea"
                        item-text="nombreArea"
                        :items="areas"
                        label="Área"
                        v-model="editedItem.idArea"
                        variant="outlined"
                        hide-details
                        class="modern-field"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        v-model="editedItem.telefono"
                        label="Teléfono"
                        variant="outlined"
                        hide-details
                        class="modern-field"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        v-model="editedItem.firma"
                        label="Firma"
                        variant="outlined"
                        hide-details
                        class="modern-field"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions class="dialog-actions">
                <v-spacer></v-spacer>
                <v-btn color="grey" text @click="close" class="cancel-btn">
                  Cancelar
                </v-btn>
                <v-btn
                  color="primary"
                  @click="save"
                  :disabled="
                    !editedItem.cedula ||
                    !editedItem.nombre ||
                    !editedItem.contrasena ||
                    !editedItem.telefono ||
                    !editedItem.firma ||
                    !editedItem.correo ||
                    !editedItem.idArea ||
                    !editedItem.idRol
                  "
                  class="save-btn"
                >
                  Guardar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </div>

      <!-- Search Section -->
      <div class="search-section">
        <div class="search-card">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar Usuario"
            solo
            flat
            hide-details
            class="search-field"
          ></v-text-field>
        </div>
      </div>

      <!-- Table Section -->
      <div class="table-section">
        <div class="table-card">
          <v-data-table
            :headers="headers"
            :items="usuarios"
            :search="search"
            class="modern-table"
            :items-per-page="10"
            :footer-props="{
              'items-per-page-options': [10, 20, 50],
              'items-per-page-text': 'Filas por página:',
            }"
          >
            <template v-slot:no-data>
              <v-alert
                :value="true"
                color="#F44336"
                icon="mdi-alert"
                outlined
                type="warning"
                prominent
                border="left"
              >
                <strong>No</strong> se encontró su búsqueda
              </v-alert>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <div class="action-icons">
                <v-icon
                  class="action-icon edit-icon"
                  @click="editItem(item)"
                  title="Editar Usuario"
                >
                  mdi-pencil
                </v-icon>
                <v-icon
                  v-if="item.estado_usuario == 1"
                  class="action-icon activate-icon"
                  @click="inactivateItem(item, 0)"
                  title="Desactivar Usuario"
                >
                  mdi-toggle-switch
                </v-icon>
                <v-icon
                  v-else
                  class="action-icon deactivate-icon"
                  @click="activateItem(item, 1)"
                  title="Activar Usuario"
                >
                  mdi-toggle-switch-off
                </v-icon>
              </div>
            </template>
          </v-data-table>
        </div>
      </div>

      <!-- Snackbar para notificaciones -->
      <v-snackbar
        v-model="snackbar"
        :bottom="y === 'bottom'"
        :left="x === 'left'"
        :multi-line="mode === 'multi-line'"
        :right="x === 'right'"
        :timeout="timeout"
        :top="y === 'top'"
        :vertical="mode === 'vertical'"
        color="#3b82f6"
        class="modern-snackbar"
      >
        {{ text }}
        <v-btn color="white" text @click="snackbar = false">Cerrar</v-btn>
      </v-snackbar>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import env from "../env";
import swal from "sweetalert";
export default {
  data() {
    return {
      ex4: ["p"],
      show: false,
      snackbar: false,
      y: "top",
      x: null,
      mode: "",
      estadoV: true,
      timeout: 6000,
      text: "",
      search: "",
      usuarios: [],
      roles: [],
      areas: [],
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Maximo 20 characteres",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalido e-mail.";
        },
      },
      dialog: false,
      headers: [
        {
          text: "Cédula",
          align: "center",
          value: "cedula",
          class: "column",
        },
        {
          text: "Nombre",
          value: "nombre",
          align: "center",
          class: "column",
        },
        {
          text: "Correo Corporativo",
          value: "correo",
          align: "center",
          class: "column",
        },
        {
          text: "Rol",
          value: "nombreRol",
          align: "center",
          class: "column",
        },
        {
          text: "Área",
          value: "nombreArea",
          align: "center",
          class: "column",
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
          align: "center",
          class: "column",
        },
      ],
      defaultItem: {
        idUsuario: "",
        nombre: "",
        cedula: "",
        contrasena: "",
        idRol: "",
        idArea: "",
        correo: "",
        telefono: "",
        firma: "",
      },
      editedIndex: -1,
      editedItem: {
        idUsuario: "-",
        nombre: "",
        cedula: "",
        contrasena: "",
        idRol: "",
        idArea: "",
        correo: "",
        telefono: "",
        firma: "",
      },
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Usuario" : "Editar Usuario";
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  mounted() {
    this.obtenerTodo();
    this.obtenerUsuarios();
  },

  methods: {
    // Metodo para obtener los usuarios
    obtenerUsuarios() {
      axios.get(`${env.endpoint}user/usuarios`).then((res) => {
        this.usuarios = res.data;
      });
    },
    /**
    /**
     * Metodo para obtener roles
     */
    obtenerTodo() {
      axios.get(`${env.endpoint}user/roles`).then((res) => {
        this.roles = res.data;
      });
      axios.get(`${env.endpoint}user/areas`).then((res) => {
        this.areas = res.data;
      });
    },

    /**
     * Metodo para agregar fila de la tabla en la modal
     */
    editItem(item) {
      this.editedIndex = this.usuarios.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    /**
     * Metodo para cerrar la modal
     */
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    /**
     * Metodo para guardar y actualizar
     */
    save() {
      if (this.editedIndex > -1) {
        const modificarUsuario = new FormData();
        modificarUsuario.append("idUsuario", this.editedItem.idUsuario);
        modificarUsuario.append("nombre", this.editedItem.nombre);
        modificarUsuario.append("cedula", this.editedItem.cedula);
        modificarUsuario.append("idRol", this.editedItem.idRol);
        modificarUsuario.append("idArea", this.editedItem.idArea);
        modificarUsuario.append("correo", this.editedItem.correo);
        modificarUsuario.append("contrasena", this.editedItem.contrasena);
        modificarUsuario.append("telefono", this.editedItem.telefono);
        modificarUsuario.append("firma", this.editedItem.firma);

        axios
          .post(`${env.endpoint}user/modificar_user`, modificarUsuario, {})
          .then((res) => {
            this.obtenerUsuarios();
          });

        swal({
          title: "Usuario Modificado",
          text: "Usuario modificado satisfactoriamente",
          icon: "success",
          buttons: ["Cancelar", true],
        });
      } else {
        const crearUsuario = new FormData();
        crearUsuario.append("nombre", this.editedItem.nombre);
        crearUsuario.append("cedula", this.editedItem.cedula);
        crearUsuario.append("idRol", this.editedItem.idRol);
        crearUsuario.append("idArea", this.editedItem.idArea);
        crearUsuario.append("correo", this.editedItem.correo);
        crearUsuario.append("contrasena", this.editedItem.contrasena);
        crearUsuario.append("telefono", this.editedItem.telefono);
        crearUsuario.append("firma", this.editedItem.firma);

        axios
          .post(`${env.endpoint}user/create_user`, crearUsuario, {})
          .then((res) => {
            this.obtenerUsuarios();
          });
        swal({
          title: "Usuario creado",
          text: "Usuario creado satisfactoriamente",
          icon: "success",
          buttons: ["Cancelar", true],
        });
      }
      this.obtenerUsuarios();
      this.close();
    },

    activateItem(item, estado) {
      swal({
        title: "Este usuario se activara del sistema.",
        text: "¿Estas seguro de activar al usuario?",
        icon: "warning",
        buttons: ["Cancelar", true],
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          axios
            .get(`${env.endpoint}user/estado_Usuario`, {
              params: {
                idUsuario: item.idUsuario,
                estado: estado,
              },
            })
            .then((res) => {
              swal("Usuario activado con exito!", {
                icon: "success",
              });
            })
            .catch((error) => {
              this.text =
                "Ha ocurrido un error, intente de nuevo. Si el problema persiste comuníquese con el área de sistemas";
            })
            .finally(() => {
              this.obtenerUsuarios();
            });
        } else {
          swal("Proceso de activacion cancelado");
        }
      });
    },

    inactivateItem(item, estado) {
      swal({
        title: "Este usuario se inactivara del sistema.",
        text: "¿Estas seguro de inactivar al usuario?",
        icon: "warning",
        buttons: ["Cancelar", true],
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          axios
            .get(`${env.endpoint}user/estado_Usuario`, {
              params: {
                idUsuario: item.idUsuario,
                estado: estado,
              },
            })
            .then((res) => {
              swal("Usuario inactivado con exito!", {
                icon: "success",
              });
            })
            .catch((error) => {
              this.text =
                "Ha ocurrido un error, intente de nuevo. Si el problema persiste comuníquese con el área de sistemas";
            })
            .finally(() => {
              this.obtenerUsuarios();
            });
        } else {
          swal("Proceso de inactivacion cancelado");
        }
      });
    },
  },
};
</script>

<style scoped>
/* ===== CONTAINER PRINCIPAL ===== */
.usuarios-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  padding: 2rem;
}

.unified-container {
  max-width: 1800px;
  margin: 0 auto;
  background: white;
  border-radius: 0;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

/* ===== HEADER SECTION ===== */
.header-section {
  background: linear-gradient(135deg, #3b82f6 0%, #1e40af 100%);
  padding: 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
}

.title-section {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.title-icon {
  width: 50px;
  height: 50px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.title-text {
  display: flex;
  flex-direction: column;
}

.main-title {
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.subtitle {
  font-size: 1rem;
  margin: 0.25rem 0 0 0;
  opacity: 0.9;
  font-weight: 400;
}

.action-section {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.create-btn {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
  color: white !important;
  font-weight: 600 !important;
  text-transform: none !important;
  border-radius: 8px !important;
  padding: 0.75rem 1.5rem !important;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3) !important;
  transition: all 0.3s ease !important;
}

.create-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(16, 185, 129, 0.4) !important;
}

/* ===== SEARCH SECTION ===== */
.search-section {
  padding: 1.5rem 2rem;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.search-card {
  max-width: 400px;
  margin: 0 auto;
}

.search-field {
  background: white !important;
  border-radius: 8px !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05) !important;
}

/* ===== TABLE SECTION ===== */
.table-section {
  padding: 0;
}

.table-card {
  background: white;
  border-radius: 0;
  overflow: hidden;
}

.modern-table {
  background: white;
}

.modern-table >>> .v-data-table__wrapper {
  border: none;
  border-radius: 0;
}

.modern-table >>> .v-data-table-header {
  background: #f8fafc;
  border-bottom: 2px solid #e2e8f0;
}

.modern-table >>> .v-data-table-header th {
  color: #374151 !important;
  font-weight: 600 !important;
  font-size: 0.875rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 1rem 0.75rem !important;
}

.modern-table >>> .v-data-table__wrapper table tbody tr {
  border-bottom: 1px solid #f1f5f9;
  transition: all 0.2s ease;
}

.modern-table >>> .v-data-table__wrapper table tbody tr:nth-child(even) {
  background: #f8fafc;
}

.modern-table >>> .v-data-table__wrapper table tbody tr:hover {
  background: #eff6ff !important;
  transform: none;
}

.modern-table >>> .v-data-table__wrapper table tbody tr td {
  padding: 1rem 0.75rem !important;
  color: #374151 !important;
  font-size: 0.875rem !important;
}

/* ===== ACTION ICONS ===== */
.action-icons {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  justify-content: center;
}

.action-icon {
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 1.25rem !important;
  padding: 0.25rem;
  border-radius: 4px;
}

.edit-icon {
  color: #3b82f6 !important;
}

.edit-icon:hover {
  color: #1d4ed8 !important;
  transform: scale(1.1);
}

.activate-icon {
  color: #10b981 !important;
}

.activate-icon:hover {
  color: #059669 !important;
  transform: scale(1.1);
}

.deactivate-icon {
  color: #ef4444 !important;
}

.deactivate-icon:hover {
  color: #dc2626 !important;
  transform: scale(1.1);
}

/* ===== TABLE FOOTER ===== */
.modern-table >>> .v-data-footer {
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
  padding: 1rem;
}

.modern-table >>> .v-data-footer__select {
  color: #6b7280 !important;
  font-size: 0.875rem !important;
}

.modern-table >>> .v-data-footer__pagination {
  color: #6b7280 !important;
  font-size: 0.875rem !important;
}

.modern-table >>> .v-data-footer .v-btn {
  color: #6b7280 !important;
}

/* ===== DIALOG STYLES ===== */
.modern-dialog {
  border-radius: 12px !important;
  overflow: hidden;
}

.dialog-header {
  background: linear-gradient(135deg, #3b82f6 0%, #1e40af 100%) !important;
  color: white !important;
  padding: 1.5rem !important;
}

.dialog-title {
  font-size: 1.25rem !important;
  font-weight: 600 !important;
}

.dialog-content {
  padding: 2rem !important;
}

.modern-field {
  margin-bottom: 1rem !important;
}

.modern-field >>> .v-input__control {
  min-height: 48px !important;
}

.modern-field >>> .v-field {
  border-radius: 8px !important;
}

.dialog-actions {
  padding: 1rem 2rem 2rem 2rem !important;
  background: #f8fafc;
}

.cancel-btn {
  margin-right: 1rem !important;
  text-transform: none !important;
  font-weight: 500 !important;
}

.save-btn {
  text-transform: none !important;
  font-weight: 600 !important;
  padding: 0.75rem 2rem !important;
}

/* ===== SNACKBAR ===== */
.modern-snackbar {
  border-radius: 8px !important;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3) !important;
}

/* ===== RESPONSIVE DESIGN ===== */
@media (max-width: 768px) {
  .usuarios-container {
    padding: 1rem;
  }

  .header-section {
    flex-direction: column;
    gap: 1.5rem;
    text-align: center;
  }

  .title-section {
    flex-direction: column;
    gap: 0.75rem;
  }

  .main-title {
    font-size: 1.5rem;
  }

  .search-section {
    padding: 1rem;
  }

  .search-card {
    max-width: 100%;
  }

  .action-icons {
    flex-direction: column;
    gap: 0.25rem;
  }

  .action-icon {
    width: 28px;
    height: 28px;
    font-size: 1rem !important;
  }
}

@media (max-width: 480px) {
  .main-title {
    font-size: 1.25rem;
  }

  .subtitle {
    font-size: 0.875rem;
  }

  .create-btn {
    padding: 0.5rem 1rem !important;
    font-size: 0.875rem !important;
  }
}
</style>
